import { Routine, ROUTINE_TYPES, ExerciseOrSuperset, RoutineExerciseHashMap } from '../../../types/Fisiofit/routine';
import { ExternalUserShort } from '../../../types/externalUser';
import { isSuperset } from '../../../utils/supersetUtils';
import { unCapitalize } from '../../../utils/textUtils';
import { RoutineForm } from '../validators';

export const getDayExercisesWithPreloadValues = (
  exercises: ExerciseOrSuperset[],
  exercisePreloadValues: RoutineExerciseHashMap | undefined,
) => {
  if (!exercisePreloadValues) return [...exercises];
  return exercises.map((exerciseOrSuperset) => {
    if (isSuperset(exerciseOrSuperset)) {
      return exerciseOrSuperset.map((exercise) => {
        const preloadValues = exercisePreloadValues?.[exercise.exerciseId];
        return {
          ...exercise,
          ...preloadValues,
        };
      });
    }
    const preloadValues = exercisePreloadValues?.[exerciseOrSuperset.exerciseId];
    return {
      ...exerciseOrSuperset,
      ...preloadValues,
    };
  });
};

export const getRoutinePanelTitle = (isCreating: boolean, isEditing: boolean): string => {
  if (!isCreating && isEditing) {
    return 'Editar rutina';
  }
  if (!isCreating && !isEditing) {
    return 'Detalle de rutina';
  }
  if (isCreating && !isEditing) {
    return 'Crear nueva rutina';
  }
  return 'Rutina';
};

export const getUserRoutineName = (externalUser: ExternalUserShort): string => {
  const fullName = `${externalUser.name} ${externalUser.surnames}`;
  return `Rutina de ${fullName}`;
};

export const getRoutineDisplayName = (name: string | undefined, isNextRoutine = false): string => {
  if (!name) return '-';
  if (isNextRoutine) return `Próxima ${unCapitalize(name)}`;
  return name;
};

export const getInitialRoutineForm = (routine?: Routine): RoutineForm => {
  const { name, exerciseDays, localStartDate, duration, externalUser, description } = routine ?? {};
  return {
    name,
    exerciseDays: exerciseDays?.map((day) => ({ ...day, id: `day-${day.dayNumber}` })) || [],
    duration: duration ?? null,
    localStartDate: localStartDate ?? new Date().toISOString(),
    externalUser,
    description,
    routineType: routine ? (externalUser ? ROUTINE_TYPES.USER : ROUTINE_TYPES.TEMPLATE) : ROUTINE_TYPES.USER,
  };
};
